import { render } from "./PalomasView.vue?vue&type=template&id=00440b0e&scoped=true"
import script from "./PalomasView.vue?vue&type=script&lang=js"
export * from "./PalomasView.vue?vue&type=script&lang=js"

import "./PalomasView.vue?vue&type=style&index=0&id=00440b0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00440b0e"]])

export default __exports__